@use '../../../../app/styles/common/mixins';

.sellerDetails {
  display: flex;
  flex-direction: column;
  gap: var(--spasing16);
}

.summary {
  display: flex;
  flex-direction: column;
  gap: var(--spasing16);
}
